import { ReactElement } from "react";
import { localize } from "src/l10n";
import { UnstyledButton } from "src/ui";
import ContentWithUnreadIndicator from "src/ui/components/UnreadIndicator/ContentWithUnreadIndicator";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import useAttention from "../../useAttention";
import AttentionIndicator from "../AttentionIndicator/AttentionIndicator";

interface IProps {
    fontColor: spintrColors;
    isActive: boolean;
    unreadCount: number;
    onClick: () => void;
}

/**
 * The bell in the top bar.
 *
 * For anyone the surface is not switched on for this is the bell exactly as it
 * was: the same wrapper, the same badge, the same number. Only where Just nu
 * applies does the badge change meaning.
 */
function AttentionBell(props: IProps): ReactElement {
    const { fontColor, isActive, unreadCount, onClick } = props;

    const { list } = useAttention();

    const isApplicable = !!list?.applicable;
    const count = list?.count ?? 0;
    const overdueCount = list?.rows.filter((row) => row.isOverdue).length ?? 0;

    const label = isApplicable
        ? `${localize("ATTENTION_BELL_LABEL")}, ${count} ${localize("ATTENTION_BELL_TODO")}, ${unreadCount} ${localize("ATTENTION_BELL_UNREAD")}`
        : localize("Notiser");

    const icon = (
        <Visage2Icon
            icon="notification"
            color={fontColor}
        />
    );

    return (
        <UnstyledButton
            ariaLabel={label}
            onClick={onClick}
        >
            <div
                className="notifications-link link circle header-gradient-border no-user-select svg-animation icon-animation animation-pulse"
                id="notifications-link"
                title={isApplicable ? localize("ATTENTION_BELL_LABEL") : localize("Notiser")}
            >
                {isApplicable ? (
                    <AttentionIndicator
                        count={count}
                        overdueCount={overdueCount}
                        unreadCount={unreadCount}
                    >
                        {icon}
                    </AttentionIndicator>
                ) : (
                    <ContentWithUnreadIndicator
                        margin={11}
                        active={isActive}
                        count={unreadCount}
                        secondaryPlacement={true}
                    >
                        {icon}
                    </ContentWithUnreadIndicator>
                )}
            </div>
        </UnstyledButton>
    );
}

export default AttentionBell;
